import { Link } from "react-router-dom";
import { BellRing, HandHeart } from "lucide-react";
import { useRedEstado } from "@/lib/red";

const Pill = ({ to, icon: Icon, label, count, testid }) => (
  <Link to={to} data-testid={testid} className="flex-1 c-card px-3 py-2.5 flex items-center gap-2 active:scale-[0.98] transition-transform">
    <span className="relative"><Icon className="w-5 h-5 c-accent" />
      {count > 0 && <span data-testid={`${testid}-badge`} className="absolute -top-1.5 -right-2 min-w-[17px] h-[17px] px-1 rounded-full bg-[#dc2626] text-white text-[10px] font-bold flex items-center justify-center">{count}</span>}
    </span>
    <span className="text-sm font-semibold">{label}</span>
  </Link>
);

export const RedShortcuts = () => {
  const [e] = useRedEstado();
  return (
    <div className="flex gap-2" data-testid="hoy-red-shortcuts">
      <Pill to="/conecta/avisos" icon={BellRing} label="Notificaciones" count={e?.avisos_sin_leer} testid="hoy-notif-bell" />
      <Pill to="/conecta/solicitudes" icon={HandHeart} label="Solicitudes" count={e?.solicitudes_pendientes} testid="hoy-solicitudes-link" />
    </div>
  );
};
